import { useQuery } from '@tanstack/react-query';
import { queryKeys, type CouponsListFilters } from '@/core/data-fetching/queryKeys';
import { couponsService } from '../api/coupons.service';

export function useCouponsListQuery(filters?: CouponsListFilters) {
  return useQuery({
    queryKey: queryKeys.coupons.list(filters),
    queryFn: () => couponsService.list(filters),
  });
}
